import { Recommendation } from '../../../types/types'
import { Section } from './section'
import { SupportingText } from './styles'

export interface ActionProps {
  hasStarted: boolean
  isComplete?: boolean
  outstandingAction?: Recommendation
  onStart: () => void
  onContinue: () => void
  onOutstandingAction?: () => void
}

export const Action = ({
  hasStarted,
  isComplete = false,
  outstandingAction,
  onStart,
  onContinue,
  onOutstandingAction,
}: ActionProps) => {
  if (hasStarted && outstandingAction !== undefined) {
    return (
      <Section
        title={outstandingAction.displayName}
        actionLabel="Continue referencing"
        onAction={onOutstandingAction}
      >
        <SupportingText>{outstandingAction.description}</SupportingText>
      </Section>
    )
  }

  if (isComplete) {
    return (
      <Section title="Referencing complete">
        <SupportingText>
          You're all done for now. If we need any further information or documentation from
          you, we'll be in touch.
        </SupportingText>
      </Section>
    )
  }

  if (hasStarted) {
    return (
      <Section
        title="Continue where you left off"
        actionLabel="Continue referencing"
        onAction={onContinue}
      >
        <SupportingText>
          You've completed some tasks already, you can jump back to the section you got to
          and carry on from there.
        </SupportingText>
      </Section>
    )
  }

  return (
    <Section title="Declaration" actionLabel="Start referencing" onAction={onStart}>
      <SupportingText>
        Confirming your name, and agreeing to our terms and privacy policy.
      </SupportingText>
    </Section>
  )
}
